module.exports = __webpack_public_path__ + "img/10.687300a2.jpg";